export class ObservacoesLaudosModel {
  id: string;
  observacao_pt: string;
  observacao_en: string;
  observacao_es: string;
  cor: number = 1;
}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-observacoes/observacoes-laudos.model.ts